import React, { lazy } from 'react';
type NordenVariant = 'laptop' | 'lightbulb' | 'plant' | 'rocket' | 'colors'
// Legacy aliases (backward compatibility)
| 'working' | 'shield' | 'wave';
type NordenSize = 'sm' | 'md' | 'lg' | 'xl';
interface NordenMascotProps {
  variant?: NordenVariant;
  size?: NordenSize;
  className?: string;
  alt?: string;
}
const sizeMap: Record<NordenSize, number> = {
  sm: 64,
  md: 120,
  lg: 200,
  xl: 320
};
const imageMap: Record<NordenVariant, string> = {
  laptop: 'https://cdn.magicpatterns.com/uploads/bxnkWTg1pmHguiFVCkbcdk/norden_met_laptop_en_gear_15-08.png',
  lightbulb: 'https://cdn.magicpatterns.com/uploads/uhiPp3MZg3jPZtHicXL5fS/norden_met_light_bulb.png',
  plant: 'https://cdn.magicpatterns.com/uploads/6dZrHEVKNoUSuhGGihoFNM/Norden_met_plant.png',
  rocket: 'https://cdn.magicpatterns.com/uploads/u5Q7Jx9cFVaD48nmqCDvz9/Norden_met_raket.png',
  colors: 'https://cdn.magicpatterns.com/uploads/21QQxdHhdRV8QjVRko8nTz/Norden_met_kleur_waaier.png',
  // Legacy aliases
  working: 'https://cdn.magicpatterns.com/uploads/bxnkWTg1pmHguiFVCkbcdk/norden_met_laptop_en_gear_15-08.png',
  shield: 'https://cdn.magicpatterns.com/uploads/6dZrHEVKNoUSuhGGihoFNM/Norden_met_plant.png',
  wave: 'https://cdn.magicpatterns.com/uploads/uhiPp3MZg3jPZtHicXL5fS/norden_met_light_bulb.png'
};
export function NordenMascot({
  variant = 'laptop',
  size = 'md',
  className = '',
  alt = 'Norden, de Noord Digital ijsbeer mascotte'
}: NordenMascotProps) {
  const dimension = sizeMap[size];
  const src = imageMap[variant];
  return <img src={src} alt={alt} width={dimension} height={dimension} loading="lazy" className={`select-none pointer-events-none object-contain ${className}`} style={{
    width: dimension,
    height: dimension
  }} draggable={false} data-id="element-868" />;
}